import { types } from 'mobx-state-tree'

const GeographicReportDataReduced = types.model('GeographicReportDataReduced', {
  toolTip: types.string,
  location: types.array(types.number),
  count: types.number
})

export type IGeographicReportDataReduced = typeof GeographicReportDataReduced.Type
export default GeographicReportDataReduced